import IconButton from '@material-ui/core/IconButton'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getSorting, stableSort } from '../../../../util/TableUtils'
import {
  exportFormatedMoney,
  renderRoute,
  useQueryParams,
} from '../../../../util/utils'
import EnhancedTableHead from '../../../components/TableHead'
import {
  fetchServiceCategory,
  remove,
} from '../../../service-category/ServiceCategoryActions'
import { StyledTableCellBody } from '../../../../components/hooks/BaseTableComponents'
import { Box, Grid } from '@material-ui/core'
import colors from '../../../../assets/colors'
import Icon from '@mdi/react'
import { mdiChevronRight, mdiDelete, mdiNoteEditOutline } from '@mdi/js'
import Pagination from '../../../../components/hooks/BasePagination'
import { useHistory, useLocation } from 'react-router-dom'
import styles from '../../../../resources/theme/global'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { fetchLaundryClient } from '../../point-value/PointValueActions'

function createData(id, name, status, color, cashback_conversion) {
  return { id, name, status, color, cashback_conversion }
}

const headCells = [
  {
    id: 'client_name',
    numeric: true,
    disablePadding: false,
    label: 'Cliente',
  },
  {
    id: 'points',
    numeric: true,
    disablePadding: false,
    label: 'Pontos',
  },
  {
    id: 'total_value',
    numeric: true,
    disablePadding: false,
    label: 'Total',
  },
  {
    id: 'details',
    numeric: true,
    disablePadding: false,
    label: 'Detalhado',
    align: 'center',
  },
]

const useStyles = makeStyles(theme => ({
  link: {
    padding: '0px 12px',
    borderRadius: '1.2em',
    textDecoration: 'none',
    backgroundColor: colors.primary,
    color: 'white',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: colors.primary,
      opacity: 0.7,
    },
  },
}))

const List = props => {
  const { classes } = props

  const laundryClient = useSelector(state => state.pointValue.laundryClient)
  const permissions = useSelector(state => state.auth.permissions)
  const items = useSelector(state => state.cashbackExtract.items)
  const meta = useSelector(state => state.cashbackExtract.meta)

  const styles = useStyles()

  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const filters = useQueryParams(location?.search)

  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('value')
  const [selected, setSelected] = useState([])

  const [open, setOpen] = useState(false)

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === 'desc'
    setOrder(isDesc ? 'asc' : 'desc')
    setOrderBy(property)
  }

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n.name)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }

  const handleChangeRowsPerPage = event => {
    const data = { ...filters, rows: event.target.value, page: 1 }
    handleSubmit(data)
  }

  const handleSubmit = data => {
    const searchParams = new URLSearchParams(data || filters)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const onMovePage = (event, newPage) => {
    const data = { ...filters, page: newPage }
    handleSubmit(data)
  }

  useEffect(() => {
    dispatch(fetchLaundryClient())
  }, [])

  return (
    <>
      <TableContainer className={classes?.tableStickHeader}>
        <Table
          className={classes?.table}
          aria-labelledby="Tabela de Categorias de Serviços"
        >
          <EnhancedTableHead
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={items.length}
            headCells={headCells}
            renderFirstTH={false}
          />
          <TableBody>
            {stableSort(items, getSorting(order, orderBy)).map(row => {
              return (
                <TableRow hover tabIndex={-1} key={row.id}>
                  <StyledTableCellBody>{row?.client?.name}</StyledTableCellBody>
                  <StyledTableCellBody>{row?.total_points}</StyledTableCellBody>
                  <StyledTableCellBody>
                    {exportFormatedMoney(
                      row?.total_points * laundryClient?.cashback_point_value
                    )}
                  </StyledTableCellBody>

                  <StyledTableCellBody align="center">
                    <IconButton
                      size="small"
                      component={Link}
                      to={`/cashback-module/extract/details/${row?.client_id}`}
                      className={styles.link}
                    >
                      Acessar detalhes
                      <Icon path={mdiChevronRight} size={1} />
                    </IconButton>
                  </StyledTableCellBody>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <Pagination
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={meta?.per_page}
        rows={meta?.total}
        page={meta?.current_page}
        from={meta?.from}
        to={meta?.to}
        handleChangePage={onMovePage}
      />
    </>
  )
}

export default withStyles(styles)(List)
